<script lang="ts">
    import WhiteColor from './WhiteColor.svelte';

    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean | string = false;
    export let alignIcon: string = 'right';
    export let minWidth: number = 80;
    export let colorMode: 'blue' | 'black' | 'danger' | 'green' = 'blue';
    export let displayMode: 'small' | 'standard' = 'standard';
    export let dataId: string = '';
</script>

<button
    class="btn-main dont-break align-icon-{alignIcon} colorMode-{colorMode} displayMode-{displayMode}"
    style="min-width: {minWidth}px;"
    data-id={dataId}
    class:showIcon
    class:empty={text.length === 0}
    on:click|stopPropagation
    {disabled}
>
    {#if showIcon}
        <WhiteColor>
            <icon
                style={typeof showIcon == 'string' ? 'background-image: url(' + showIcon + ')' : ''}
            ></icon>
        </WhiteColor>
    {/if}
    <span>
        {text}
    </span>
</button>

<style>
    .btn-main {
        /*background-color: var(--automapa-blue);*/
        /*background-color: #3e79ff; !* from mail *!*/
        background-color: #4978e2; /* from  https://er.automapa.pl/documents/23*/
        color: #ffffff;
        cursor: pointer;
        /*border: 1px solid var(--automapa-blue);*/
        border: 1px solid #4978e2; /* from mail */
        border-radius: 11px;
        height: 22px;
        line-height: 12px;
        font-size: 12px;
        box-sizing: border-box;
        padding: 0 10px;
        margin: 0 6px;
        position: relative;
        font-weight: 600;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
    }
    .btn-main.colorMode-black {
        background-color: #313131;
        border: 1px solid #313131;
    }
    .btn-main.colorMode-danger {
        background-color: #d93b4d;
        border: 1px solid #d93b4d;
    }
    .btn-main.colorMode-green {
        background-color: #00a651;
        border: 1px solid #00a651;
    }
    .showIcon {
        /*padding-right: 40px;*/
        text-align: left;
    }
    .btn-main icon {
        position: absolute;
        right: 5px;
        top: -6px;
        width: 14px;
        min-height: 14px;
        background-repeat: no-repeat;
        background-position: 100% center;
        background-size: 14px;
    }
    .btn-main.showIcon.align-icon-left {
        padding-left: 30px;
        padding-right: 10px;
    }
    .btn-main.align-icon-left icon {
        right: auto;
        left: 5px;
        background-position: 0% center;
    }
    .btn-main.empty {
        width: 40px;
        min-width: 40px;
    }
    .btn-main.empty icon {
        background-position: center center;
        opacity: 1;
        padding: 0;
        margin: 0;
    }

    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
        border: 1px solid var(--automapa-grey-dark);
    }
    .displayMode-small {
        min-width: unset !important;
        text-transform: lowercase;
        height: 20px;
        border-radius: 10px;
        line-height: 20px;
    }
</style>
